import React, {useEffect, useState} from 'react';
import CustomButton from "../../components/UI/customButton/customButton";
import {useTranslation} from "react-i18next";
import CustomInput from "../../components/UI/customInput/customInput";
import CustomCheckBox from "../../components/UI/customCheckBox/customCheckBox";
import {CopyIcon} from "../../icons/icons";
import {toast} from "react-toastify";
import {Get, Post} from "../../apis/api";
import {useSelector} from "react-redux";

const Profile = () => {
  // eslint-disable-next-line react-hooks/rules-of-hooks
  const { t } = useTranslation();
  const [role ,setRole] = useState(true)
  const [loading, setLoading] = useState(false)
  const [data, setData] = useState( [])
  const [form, setForm] = useState({});
  const user = useSelector((state) => state.user.user)
  const  pathname  = window.location.hostname;
  const copyToClipboard = async (text) => {
    try {
      await navigator.clipboard.writeText(text);
      toast.success(t("linkIsCopy"))

    } catch (err) {
      console.error("Failed to copy: ", err);
    }
  };
  const handleForm = ({name, value}) => {
    setForm((prevState) => ({...prevState, [name]: value}))
  }
  useEffect(() => {
    handleList()
  } ,[])


  const handleList = () => {
    setLoading(true)
    Get(`agent/profile` ).then((res) =>{
      setForm(res?.details?.data)
    }).finally(() => {
      setLoading(false)
    })
  }
  const handleSubmit = () => {
    setLoading(true)
    Post(`agent/profile/update` , {...form , "form" : "agent_update_form" }).then((res) =>{
      toast.success(res.msg)
      setData(res?.details?.data)

    }).catch((error) => {

      toast.error(error?.data?.message)
    })
      .finally(() => {
        setLoading(false)
      })
  }
  return (
    <>
      <div className={`my-container w-full pb-24`}>
        <div className={"rounded-lg bg-white p-5 grid grid-cols-1 md:grid-cols-2 gap-4 px-4 md:px-[10%]"}>
          <CustomInput
            placeHolder={t("name")}
            label={t("name")}
            name={"name"}
            defaultValue={form["name"]}
            onchange={(e) => handleForm(e)}
          />
          <CustomInput
            placeHolder={t("family")}
            label={t("family")}
            name={"last_name"}
            defaultValue={form["last_name"]}
            onchange={(e) => handleForm(e)}
          />
          <CustomInput
            placeHolder={t("meli")}
            label={t("meli")}
            name={"notional_code"}
            defaultValue={form["notional_code"]}
            onchange={(e) => handleForm(e)}
          />
          <CustomInput
            placeHolder={t("tel")}
            label={t("tel")}
            name={"mobile"}
            defaultValue={form["mobile"]}
            onchange={(e) => handleForm(e)}
          />
        </div>
        <div className={"rounded-lg bg-white p-5 grid-cols-1 grid md:grid-cols-2 gap-4 px-4 md:px-[10%] mt-5 gap-4"}>
          <div className={"md:col-span-2"}>
            <CustomInput
              placeHolder={t("email")}
              label={t("email")}
              name={"email"}
              defaultValue={form["email"]}
              onchange={(e) => handleForm(e)}
            />
          </div>
          <CustomInput
            placeHolder={t("profilePassword")}
            label={t("profilePassword")}
            name={"password"}
            defaultValue={form["password"]}
            onchange={(e) => handleForm(e)}
            type={"password"}
          />
          <CustomInput
            type={"password"}
            placeHolder={t("repeatPassword")}
            label={t("repeatPassword")}
            name={"repeatPassword"}
            defaultValue={form["repeatPassword"]}
            onchange={(e) => handleForm(e)}
          />
          <span className={"md:col-span-2"}>
            <CustomCheckBox onCheck={() => setRole(!role)} label={"passwordRole"}/>
          </span>

          <div className={" w-full md:col-span-2"}>
            <CustomButton loading={loading} onClick={handleSubmit}  disable={role} title={t("save")}/>
          </div>
        </div>
        <div className={"rounded-lg bg-white p-5 grid grid-cols-1 gap-4 px-4 md:px-[10%] border mt-10"}>
          <div className={"w-full text-center"}>
            {t("crewLink")}
          </div>
          <div onClick={() => copyToClipboard(`https://${pathname}/crew/auth/register/${user?.referral_code}`)} className={"w-full text-center flex items-center justify-center cursor-pointer"}>
             <span className={"px-5"}>
               <CopyIcon/>
             </span>
            <span className={"text-gray-500 select-none"}>
               {`https://${pathname}/crew/auth/register/${user?.referral_code}`}
             </span>
          </div>
        </div>
      </div>
    </>
  );
};

export default Profile;
